import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackPageViewEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackPageView = (
  market: Market,
  vehicle?: ElasticVehicle,
): LegacyTrackPageViewEventData => {
  const eventData: LegacyTrackPageViewEventData = {
    eventType: 'pageview',
    documentTitle: document.title,
  };

  if (vehicle) {
    eventData.item = mapElasticVehicleToLegacyItem(market, vehicle);
  }

  return eventData;
};

export const useLegacyTrackPageView = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyPageView = useCallback(
    (vehicle?: ElasticVehicle) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'pageview',
        data: createLegacyTrackPageView(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyPageView,
  };
};
